import api from './api';

export const getMyGamification           = ()               => api.get('/api/gamification/me');
export const getAllBadges                 = ()               => api.get('/api/gamification/badges');
export const getAllTimeLeaderboard        = ()               => api.get('/api/league/alltime');
export const recognizeStudent            = (profileId, data) => api.post(`/api/gamification/recognize/${profileId}`, data);
export const getTrainerSummary           = ()               => api.get('/api/gamification/trainer-summary');
export const getStudentGamificationAdmin = (profileId)      => api.get(`/api/gamification/student/${profileId}`);
